<!-- 由 suu 创建于 2025-05-12 星期一 -->
<template>
  <div class="DetailCaceList">
    <template v-for="(item, index) in caseList">
      <div
        :key="index"
        class="d-cases-item"
        @click="handleClick(item, index)"
        v-if="item.old_img && item.new_img"
      >
        <div class="item-top">
          <div class="top-left">
            <div class="left-text">before</div>
            <img class="top-img" :src="item.old_img" alt="" />
          </div>
          <div class="top-right">
            <div class="right-text">after</div>
            <img class="top-img" :src="item.new_img" alt="" />
          </div>
          <div class="top-user">
            本案例已获会员<span class="user-img-box"><img class="user-img" :src="item.image" alt="" /></span><span
              class="user-name"
              >{{
                item.truename[0] + '*'.repeat(item.truename.length - 1)
              }}</span
            >授权使用
          </div>
          <img
            class="top-jt-img"
            src="https://cdnvue.gymcity.com.cn/uploads/25coach-case-jt"
            alt=""
          />
        </div>
        <div class="item-bottom">
          <div class="bottom-left">
            <div class="left-day">{{ item.day_num }}</div>
            <div class="left-target">{{ item.target }}</div>
          </div>
          <div class="bottom-right">
            <div class="right-item">
              <div class="item-title">体重</div>
              <div class="item-value"
                ><img
                  :src="
                    Number(item.weight_change) > 0
                      ? 'https://cdnvue.gymcity.com.cn/uploads/25coach-case-change-zj'
                      : 'https://cdnvue.gymcity.com.cn/uploads/25coach-case-change-js'
                  "
                  alt=""
                />{{ item.weight_change }}kg</div
              >
            </div>
            <div class="right-hr"></div>
            <div class="right-item">
              <div class="item-title">体脂率</div>
              <div class="item-value"
                ><img
                  :src="
                    Number(item.bfr_change) > 0
                      ? 'https://cdnvue.gymcity.com.cn/uploads/25coach-case-change-zj'
                      : 'https://cdnvue.gymcity.com.cn/uploads/25coach-case-change-js'
                  "
                  alt=""
                />{{ item.bfr_change }}%</div
              >
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'DetailCaceList',

  components: {},

  props: {
    caseList: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {}
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {
    handleClick(item, index) {
      this.$http.get('member/index?a=shareLogPush', {
        from: `教练主页-点击案例查看`,
        from_id: 250326
      })
      this.$emit('caseClick', item)
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.DetailCaceList {
  width: 100%;
  box-sizing: border-box;
  padding: 0 vw(16);
  margin-top: vw(20);
  position: relative;
  .d-cases-item {
    width: 100%;
    box-sizing: border-box;
    margin-bottom: vw(10);
    border-radius: vw(4);
    overflow: hidden;
    .item-top {
      width: 100%;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      position: relative;
      .top-left,
      .top-right {
        flex: 1;
        position: relative;
        .left-text,
        .right-text {
          width: vw(58);
          height: vw(22);
          background: #ff2270;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: vw(14);
          color: #ffffff;
          position: absolute;
          top: 0;
          right: 0;
        }
        .right-text {
          background: #24c789;
          right: auto;
          left: 0;
        }
        .top-img {
          width: 100%;
          height: vw(228);
          object-fit: cover;
        }
      }
      .top-user {
        width: 100%;
        box-sizing: border-box;
        height: vw(17);
        background: linear-gradient(
          90deg,
          rgba(0, 0, 0, 0) 0%,
          rgba(0, 0, 0, 0) 40%,
          rgba(0, 0, 0, 0.4) 100%
        );
        padding-right: vw(10);
        display: flex;
        align-items: center;
        justify-content: flex-end;
        font-size: vw(9);
        color: #ffffff;
        position: absolute;
        bottom: 0;
        left: 0;
        .user-img-box {
          width: vw(10);
          height: vw(10);
          border-radius: 50%;
          margin-left: vw(3);
          overflow: hidden;
          position: relative;
          display: inline-block;
          vertical-align: middle;
          .user-img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
          &::after {
            content: '';
            display: block;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.1);
            border-radius: 50%;
            backdrop-filter: blur(2px);
            position: absolute;
            top: 0;
            left: 0;
          }
        }
        .user-name {
          margin-left: vw(2);
          margin-right: vw(3);
        }
      }
    }
    .item-bottom {
      width: 100%;
      height: vw(71);
      background: #f5f5f5;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      padding-left: vw(14);
      padding-right: vw(10);
      .bottom-left {
        flex: 1;
        .left-day {
          font-size: vw(16);
          color: #050b27;
          font-weight: 550;
        }
        .left-target {
          font-size: vw(12);
          color: rgba($color: #050b27, $alpha: 0.78);
          margin-top: vw(3);
        }
      }
      .bottom-right {
        width: vw(194);
        height: vw(51);
        box-sizing: border-box;
        background: #ffffff;
        border-radius: vw(4);
        display: flex;
        align-items: center;
        justify-content: space-between;
        .right-hr {
          width: 1px;
          height: vw(31);
          background-color: rgba($color: #000000, $alpha: 0.2);
        }
        .right-item {
          flex: 1;
          padding-left: vw(20);
          box-sizing: border-box;
          &:last-child {
            padding-left: vw(25);
          }
          .item-title {
            font-size: vw(10);
            color: rgba($color: #050b27, $alpha: 0.5);
            font-weight: 500;
          }
          .item-value {
            font-size: vw(20);
            color: #050b27;
            font-weight: 600;
            margin-top: vw(1);
            display: flex;
            align-items: baseline;
            font-family: DINCondensed-Bold;
            img {
              width: vw(10);
              margin-right: vw(3);
            }
          }
        }
      }
    }
    .top-jt-img {
      width: vw(66);
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}
</style>
